import { StoreThunkDispatch } from 'store/state'
import { V1 } from './net'

export function getErrors(period: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.getErrors(period))
  }
}
